import { ParsedClientTag } from '@hellodarwin/core/lib/features/entities/tags-entities';
import Service from '@hellodarwin/icons/dist/icons/Service';
import TabArrow from '@hellodarwin/icons/dist/icons/TabArrow';
import Select, { SelectProps } from 'antd/es/select';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const RfpServiceSelect = ({
  onChange,
  value,
  tags,
}: {
  onChange?: (value: string) => void;
  value?: string;
  tags: ParsedClientTag[];
}) => {
  const { t } = useTranslation();

  const options: SelectProps['options'] = useMemo(() => {
    const options: SelectProps['options'] = [];

    for (const tag of tags) {
      const suboptions: SelectProps['options'] = [];
      if (tag.services) {
        for (const service of tag.services) {
          suboptions.push({
            label: t(`tags|${service}`),
            value: service,
          });
        }

        options.push({
          label: t(`tags|${tag.category}`),
          options: suboptions,
        });
      }
    }

    return options;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tags]);

  return (
    <Select
      placeholder={t('rfp|submitRfpForm.placeholders.service')}
      size={'large'}
      options={options}
      onChange={onChange}
      value={value}
      showSearch
      suffixIcon={<TabArrow size={16} down />}
      prefix={<Service size={16} />}
    />
  );
};

export default RfpServiceSelect;
